import React from 'react';
import styles from './tabs.module.css';
import classNames from 'classnames';
import { safeCallback } from '../../../library';
export function Tabs(props) {
    var _a;
    var _b = props.hideMobile, hideMobile = _b === void 0 ? true : _b;
    var children = (Array.isArray(props.children) ? props.children.filter(function (d) { return !!d; }) : [props.children]).flat();
    return (React.createElement("nav", { className: classNames(styles.tabSliderHeader, 'kplr_tabSliderHeader', (_a = {}, _a[styles.static] = props.static, _a[styles.hideMobile] = hideMobile, _a)) }, children.map(function (child) {
        var _a;
        return (React.createElement("div", { key: child.props.id, className: classNames(styles.tabSliderHeaderItem, 'caption2', (_a = {}, _a[styles.active] = child.props.active, _a[styles.disabled] = child.props.disabled, _a)), onClick: function () {
                if (!child.props.disabled)
                    safeCallback(child.props.onClick);
            } }, child.props.name));
    })));
}
export default Tabs;
